import { render } from "./Payrolls.vue?vue&type=template&id=92c8e32e&scoped=true"
import script from "./Payrolls.vue?vue&type=script&lang=js"
export * from "./Payrolls.vue?vue&type=script&lang=js"

import "./Payrolls.vue?vue&type=style&index=0&id=92c8e32e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92c8e32e"]])

export default __exports__